import React, { useEffect } from 'react'

//classes
import classes from "./Game.css"

const Game = (props) => {

    useEffect(() => {
        // console.log("Rerendered")        
    }, [])

    return (     
        <div className={classes.Game} >
            <div className={classes.Video}>
                <img src={props.ImgSrc} alt="Game Illustration" type="png" width='100%' height='100%'/>
                <div className={classes.nameField}>
                    {props.Name}
                </div>
            </div>
        </div>
    )
}

export default Game
